import React from 'react'
import { graphql } from 'gatsby'
import { Background, Container, Section } from '../../components/page'
import { HeroText, HeroTitle } from '../../components/hero'
import { Image } from '../../components/image'
import { InstructionsVideo } from '../../components/instructions-video'
import { Button } from '../../components/button'
import { PlayIcon } from '../../components/icons'
import { useBrand } from '../../components/brand'
import { useSnippets } from '../../components/snippet'

import * as styles from './how-it-works-hero.module.scss'

export type HowItWorksHeroProps = Queries.HowItWorksHeroFragment

export const HowItWorksHero = ({
  title,
  text,
  image,
  mobileImage,
}: HowItWorksHeroProps) => {
  const brand = useBrand()
  const s = useSnippets()

  return (
    <Section className={styles.section} variant="hero">
      <Container className={styles.container}>
        <HeroTitle color="light">{title}</HeroTitle>
        {brand?.instructionsVideo ? (
          <InstructionsVideo src={brand?.instructionsVideo}>
            <Button
              color="secondary"
              variant="fill"
              className={styles.videoButton}
            >
              <PlayIcon size={24} />
              <span>{s.see_it_in_action}</span>
            </Button>
          </InstructionsVideo>
        ) : null}
        <HeroText color="light" center>
          {text?.text}
        </HeroText>
      </Container>
      <Container fluid>
        <Image
          className={styles.image}
          image={image}
          alt={image?.title!}
          loading="eager"
        />
        <Image
          className={styles.mobileImage}
          image={mobileImage}
          alt={image?.title!}
          loading="eager"
        />
      </Container>
      <Background variant="hero" pattern={false} />
    </Section>
  )
}

export const HowItWorksHeroFragments = graphql`
  fragment HowItWorksHeroImage on ContentfulAsset {
    __typename
    id
    title
    gatsbyImageData(width: 1100)
  }
  fragment HowItWorksHeroMobileImage on ContentfulAsset {
    __typename
    id
    title
    gatsbyImageData
  }
  fragment HowItWorksHero on ContentfulHowItWorksHero {
    __typename
    id
    title
    text {
      text
    }
    image {
      ...HowItWorksHeroImage
    }
    mobileImage {
      ...HowItWorksHeroMobileImage
    }
  }
`
